import React, { useState, useEffect, useRef, useCallback, } from 'react';
import { makeStyles } from '@material-ui/styles';

import { Page } from 'components';
import { Header, Filter, Results } from './components';
import { fetchUserParkings, } from 'firebaseHelpers/parkings'

const useStyles = makeStyles(theme => ({
  root: {
    width: theme.breakpoints.values.lg,
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3)
  },
  header: {
    marginBottom: theme.spacing(3)
  },
  filter: {
    marginTop: theme.spacing(3)
  },
  results: {
    marginTop: theme.spacing(6)
  }
}));

const UserParkingsList = (props) => {
  const classes = useStyles()
  const isCancelled = useRef(false)
  const [parkings, setParkings] = useState([])
  const [filters, setFilters] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const fetchData = useCallback(async () => {
    setIsLoading(true)
    const parkings = await fetchUserParkings(props.userInfos.parkings, filters)
    if (!isCancelled.current) {
      setIsLoading(false)
      setParkings([ ...parkings, ])
    }
  }, [props.userInfos, filters])

  useEffect(() => {
    isCancelled.current = false
    fetchData()
    return () => {
      isCancelled.current = true;
    }
  }, [ filters, fetchData, ]);

  const handleFilter = (filters) => {
    setFilters(filters)
  }

  return (
    <Page
      className={classes.root}
      title="Parkings List"
    >
      <Header className={classes.header} />
      <Filter onFilter={handleFilter} className={classes.filter} isLoading={isLoading}/>
      <Results className={classes.results} parkings={parkings} isLoading={isLoading}/>
    </Page>
  );
};

export default UserParkingsList;
